import { styled,keyframes } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const SelectionButton = styled(Button)({
  borderRadius: 0,
  width: 300,
  height: 50,
});

export const SquareButton = styled(Button)({
  // backgroundColor: "#1c355e", // unnecessarily overrides theme colors
  borderRadius: 3,
  border: 0,
  color: "#fff",
  height: 54,
  minWidth: 54,
  width: 54,
});

 // not used currently
export const SmallSquareButton = styled(Button)({
  // backgroundColor: "#1c355e",// unnecessarily overrides theme colors
  borderRadius: 3,
  border: 0,
  color: "#fff",
  height: 36,
  minWidth: 36,
  width: 36,
});

// not used currently
export const CircleButton = styled(Button)({
  // backgroundColor: "#1c355e",// unnecessarily overrides theme colors
  borderRadius: "50%",
  border: 0,
  color: "#fff",
  height: 54,
  minWidth: 54,
  width: 54,
});

// not used currently
export const SmallCircleButton = styled(Button)({
  backgroundColor: "#84d225",
  borderRadius: "50%",
  border: 0,
  color: "#fff",
  height: 40,
  minWidth: 40,
  width: 40,
  // "&:hover": {
  //   backgroundColor: "#76bc21", // override hover with secondary color // only used once.
  // },
});

export const SecondaryCircleButton = styled(Button)({
  backgroundColor: "#e2e2e2",
  borderRadius: "50%",
  border: 0,
  color: "#111",
  height: 54,
  minWidth: 54,
  width: 54,
});

export const ExitButton = styled(Button)({
  backgroundColor: "#d1495b",
  borderRadius: 3,
  color: "#fff",
  height: 54,
  minWidth: 54,
  width: 54,
  "&:hover": {
    backgroundColor: "#b82f41",
  },
});

export const GreenSelectionButton = styled(Button)({
  backgroundColor: "#9dba79",
  boxShadow:
    "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
  color: "#fff",
  borderRadius: 0,
  width: 300,
  height: 50,
  "&:hover": {
    backgroundColor: "#84a957",
  },
});

export const RedSelectionButton = styled(Button)({
  backgroundColor: "#d1495b",
  color: "#fff",
  borderRadius: 0,
  width: 300,
  height: 50,
  "&:hover": {
    backgroundColor: "#b82f41",
  },
});

export const GreenButton = styled(Button)({
  backgroundColor: "#76bc21",
  boxShadow:
    "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
  color: "#fff",
  height: 50,
  "&:hover": {
    backgroundColor: "#619b1b",
  },
});


export const ItalicRedTypography = styled(Typography)({
  fontSize: "1rem",
  lineHeight: 1.5,
  color: "#d1495b",
  fontStyle: "italic",
});

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const GlowingGreenButton = styled(Button)({
  position: "relative",
  overflow: "hidden",
  borderRadius: 8,
  color: "#fff",
  padding: "10px 24px",
  backgroundColor: "#76bc21",
  fontWeight: "bold",
  zIndex: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  // animated outer border
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-2px",
    left: "-2px",
    right: "-2px",
    bottom: "-2px",
    background:
      "conic-gradient(from 0deg, #76bc21, #a3e635, #c0ff6f, #76bc21)",
    animation: `${rotate} 2s linear infinite`,
    zIndex: 0,
    borderRadius: 10,
  },

  // solid inner background layer
  "&::after": {
    content: '""',
    position: "absolute",
    top: "2px",
    left: "2px",
    right: "2px",
    bottom: "2px",
    backgroundColor: "#76bc21",
    borderRadius: 8,
    zIndex: 1,
  },

  // ensure visible content sits above the pseudo-elements
  "& > *": {
    position: "relative",
    zIndex: 2,
  },

  "&:hover": {
    backgroundColor: "#619b1b",
  },
});

